var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12517_490627",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12517_490627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.82461 19.8512C5.10794 19.1346 4.55794 18.3117 4.17461 17.3827C3.79128 16.4537 3.59961 15.4932 3.59961 14.5012C3.59961 13.3679 3.79128 12.2971 4.17461 11.2887C4.55794 10.2804 5.11628 9.3929 5.84961 8.62623C6.43294 8.00957 7.08711 7.5054 7.81211 7.11373C8.53711 6.72207 9.40794 6.42623 10.4246 6.22623C11.4413 6.02623 12.6454 5.91373 14.0371 5.88873C15.4288 5.86373 17.0746 5.9179 18.9746 6.05123C19.1413 8.20123 19.2329 10.0096 19.2496 11.4762C19.2663 12.9429 19.1954 14.1846 19.0371 15.2012C18.8788 16.2179 18.6204 17.0721 18.2621 17.7637C17.9038 18.4554 17.4246 19.1012 16.8246 19.7012C16.0579 20.4846 15.2062 21.0804 14.2693 21.4887C13.3324 21.8971 12.3759 22.1012 11.3996 22.1012C10.3329 22.1012 9.32044 21.9096 8.36211 21.5262C7.40378 21.1429 6.55794 20.5846 5.82461 19.8512ZM8.39961 19.5512C8.86628 19.8012 9.34961 19.9929 9.84961 20.1262C10.3496 20.2596 10.8663 20.3179 11.3996 20.3012C12.1496 20.2846 12.8663 20.1221 13.5496 19.8137C14.2329 19.5054 14.8996 19.0429 15.5496 18.4262C15.9829 18.0096 16.3413 17.5012 16.6246 16.9012C16.9079 16.3012 17.1204 15.5679 17.2621 14.7012C17.4038 13.8346 17.4788 12.8304 17.4871 11.6887C17.4954 10.5471 17.4413 9.23457 17.3246 7.75123C16.0579 7.65123 14.8954 7.6179 13.8371 7.65123C12.7788 7.68457 11.8246 7.78873 10.9746 7.96373C10.1246 8.13873 9.38294 8.38457 8.74961 8.70123C8.11628 9.0179 7.59128 9.40123 7.17461 9.85123C6.60794 10.4679 6.17044 11.1596 5.86211 11.9262C5.55378 12.6929 5.39961 13.4679 5.39961 14.2512C5.39961 15.0179 5.52461 15.7429 5.77461 16.4262C6.02461 17.1096 6.39128 17.7429 6.87461 18.3262C7.52461 16.9596 8.38711 15.7346 9.46211 14.6512C10.5371 13.5679 11.7829 12.6512 13.1996 11.9012C11.8996 13.0512 10.8704 14.2471 10.1121 15.4887C9.35378 16.7304 8.78294 18.0846 8.39961 19.5512Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEco);
export default __webpack_public_path__ + "static/media/eco.55cbc251f822bef15aafa9e2dd8820ea.svg";
export { ForwardRef as ReactComponent };